import React, {useMemo} from "react";
import moment from "moment";
import {Badge, Descriptions, Progress} from "antd";
import {formatMomentDate} from "../../../../utils/helpers";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../../hooks/useStore";
import {SlotDetailCardPropTypes} from "./slotDetailCardPropTypes";
import {SlotDetailCardContainer, DescriptionTitle, ProgressTitle, ProgressContainer} from "./slotDetailCardStyles";

const SlotDetailCard = ({orderData}: SlotDetailCardPropTypes) => {
    const stores = useStore();
    const {t} = useTranslation(["slotDetailCard"]);

    // slot delivery time info
    const earliestStart = orderData.data?.delivery.earliestStart;
    const latestEnd = orderData.data?.delivery.latestEnd;

    // calculate capacity
    const estimation = orderData.data?.estimation;
    const operationTime = (estimation.transportTime + estimation.serviceDuration) / 60;
    const timeWindowInMinutes = moment(latestEnd).diff(moment(earliestStart), "m");
    const percentValue = parseFloat((100 * operationTime / timeWindowInMinutes).toFixed(2));

    return (
        <SlotDetailCardContainer>
            <DescriptionTitle>{t("slotDetails", {ns: "slotDetailCard"})}</DescriptionTitle>
            <Descriptions bordered>
                <Descriptions.Item span={3} label={t("start", {ns: "slotDetailCard"})}>
                    <Badge status="processing" text={formatMomentDate(earliestStart)} />
                </Descriptions.Item>
                <Descriptions.Item span={3} label={t("end", {ns: "slotDetailCard"})}>
                    <Badge status="processing" text={formatMomentDate(latestEnd)} />
                </Descriptions.Item>
            </Descriptions>
            <ProgressContainer>
                <ProgressTitle>{t("capacity", {ns: "slotDetailCard"})}</ProgressTitle>
                <Progress
                    strokeColor={{
                        "0%": "#108ee9",
                        "100%": "#87d068"
                    }}
                    percent={percentValue}
                />
            </ProgressContainer>
        </SlotDetailCardContainer>
    );
};

export default SlotDetailCard;
